"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinEntriesViewData = void 0;
const lodash_1 = require("lodash");
const assignment_1 = require("../assignment");
const entries_1 = require("../entries");
const UserReference_1 = require("./UserReference");
var PinEntriesViewData;
(function (PinEntriesViewData) {
    function data(params) {
        const pin = assignment_1.AssignmentUtils.pin(params.assignment, params.pinId);
        if (!pin) {
            return undefined;
        }
        const pinEntries = (0, lodash_1.compact)(params.entries.map((entry) => entries_1.AssignmentEntry.entryForPin(entry, params.pinId)));
        const studentPinEntries = (0, UserReference_1.userReferenceAndPinEntryFromEntries)(params.entries, pin._id);
        return {
            assignment: params.assignment,
            pinId: pin._id,
            pin,
            // TODO: pin.item.custom is removed
            // pinContent: pin.item.custom as any,
            pinEntries: pinEntries,
            studentPinEntries: studentPinEntries,
            type: pin.type,
        };
    }
    PinEntriesViewData.data = data;
})(PinEntriesViewData || (exports.PinEntriesViewData = PinEntriesViewData = {}));
//# sourceMappingURL=PinEntriesViewData.js.map